import DennyImg from "../../assets/images/Clients/Denny.png";
import VaniImg from "../../assets/images/Clients/Vani.png";
import MillyImg from "../../assets/images/Clients/Milly.png";

export const CLIENTS = [
  {
    id: "0",
    img: DennyImg,
    imgAlt: "Denny",
    description:
      "I know in real-time where the money is spent,and I don’t have to lend out the company’s credit card anymore. What a relief",
    name: "Denny Hilguston",
    address: "@denny.hill",
  },

  {
    id: "1",
    img: VaniImg,
    imgAlt: "Vani",
    description:
      "VISUALS are much better. The improvements in optics and resolution and much more than a modern console generation leap.",
    name: "Vani Pandey",
    address: "@vani.pandey",
  },

  {
    id: "2",
    img: MillyImg,
    imgAlt: "Milly",
    description:
      "I can actually see the improvement in the graphics, not having the external sensors is a big plus.",
    name: "Milly Singh",
    address: "@milly.singh",
  },
];
